import { useParams, Link } from 'react-router-dom';
import ArticleLayout from './components/ArticleLayout';
import { articlesData } from '@/mocks/articles';
import JsonLd from '@/components/base/JsonLd';
import { SITE_URL } from '@/constants';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articlesData.find((a) => a.slug === slug);

  if (!article) {
    return (
      <main className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-2xl">
            <i className="ri-file-unknow-line text-foreground-400 text-2xl"></i>
          </div>
          <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-2">Article Not Found</h2>
          <p className="text-sm text-foreground-500 mb-6">The article you are looking for does not exist or has been moved.</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Back to Homepage
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </main>
    );
  }

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.seoDescription,
    image: article.imageUrl,
    datePublished: '2026-08-06',
    dateModified: '2026-08-06',
    author: {
      '@type': 'Organization',
      name: 'Sugargoo Sheet',
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Sugargoo Sheet',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/article/${article.slug}`,
    },
    inLanguage: 'en',
  };

  return (
    <>
      <JsonLd schema={articleSchema} />
      <ArticleLayout
        title={article.title}
        subtitle={article.subtitle}
        category={article.category}
        date={article.date}
        imageUrl={article.imageUrl}
      >
        {article.sections.map((section, i) => (
          <div key={i}>
            {section.heading && (
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mt-10 mb-4">
                {section.heading}
              </h2>
            )}
            {section.paragraphs.map((paragraph, j) => (
              <p key={j} dangerouslySetInnerHTML={{ __html: paragraph }} />
            ))}
          </div>
        ))}
      </ArticleLayout>
    </>
  );
}